import script from "./Coding.vue?vue&type=script&setup=true&lang=js"
export * from "./Coding.vue?vue&type=script&setup=true&lang=js"

import "./Coding.vue?vue&type=style&index=0&id=4c2ba7f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c2ba7f0"]])

export default __exports__